const NAMES_SEPARATOR = '•';

/**
 * Displays given names in a single string
 *
 * @param name - single name or an array of names
 */
export function singleLineName(name: string | string[]): string {
  return typeof name === 'string'
    ? name
    : name.filter((name) => name.length).join(NAMES_SEPARATOR);
}
